import React, { useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./header";
import Footer from "./footer";
import { Toaster } from "react-hot-toast";

const AppLayout: React.FC = () => {

  return (
    <div className="relative flex flex-col min-h-screen pb-14 sm:pb-0">

      {/* BACKGROUND */}
      <div
        className="fixed inset-0 -z-10 bg-center bg-cover"
        // style={{
        //   backgroundImage: "url('/assets/images/bgillustra/fond.jpeg')",
        // }}
      />

      <Header />

      {/* MAIN */}
      <main className="flex-1 overflow-y-auto no-scrollbar">
        <div className="py-6 mx-auto w-full">
          <Outlet />

          <Toaster position="top-right" />
        </div>
      </main>

      <Footer />

    </div>
  );
};

export default AppLayout;